export default {
  BackCatalog: 'acast-plus-back-catalog',
};
